import { render, staticRenderFns } from "./DHYWLYWSQ.vue?vue&type=template&id=cb6ff71a&scoped=true"
import script from "./DHYWLYWSQ.vue?vue&type=script&lang=js"
export * from "./DHYWLYWSQ.vue?vue&type=script&lang=js"
import style0 from "./DHYWLYWSQ.vue?vue&type=style&index=0&id=cb6ff71a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6ff71a",
  null
  
)

export default component.exports